import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CC_OPERATIONS, CCRowSetting } from '../../../../../models/locations-models/cc-row-setting';
import { CCActionButtonsComponent } from '../../cc-action-buttons/cc-action-buttons.component';
import { GtagEventDirective } from '../../../../../core/gx-gtag/gtag-event.directive';
import { LetDirective } from '@ngrx/component';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTooltip } from '@angular/material/tooltip';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { Store } from '@ngrx/store';
import { LocationListService } from '../../../location-list/location-list.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MarkerLocation } from '../../../map/map-utils';
import * as locationListActions from '../../../location-list/state/location-list-actions';
import { CCOperationActions } from '../../state/cc-list-actions';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { AgCellRendererComponent } from '../../../../global/gx-ag-grid/ag-cell-renderer.component';
import { CCRowMenuCellLocalStoreService } from './cc-row-menu-cell-local-store.service';
import { Observable } from 'rxjs';
import { selectMarkerLocation } from '../../../map/state/map-combined.selectors';
import { CCLocation } from '../../../../../models/locations-models/cc-location';

@Component({
  selector: 'app-cc-row-menu-cell',
  standalone: true,
  imports: [
    CCActionButtonsComponent,
    GtagEventDirective,
    LetDirective,
    MatDivider,
    MatIcon,
    MatIconButton,
    MatProgressSpinner,
    MatTooltip,
    NgxSkeletonLoaderModule,
    NgTemplateOutlet,
    NgClass,
  ],
  templateUrl: './cc-row-menu-cell.component.html',
  styleUrl: './cc-row-menu-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CCRowMenuCellLocalStoreService]
})
export class CcRowMenuCellComponent extends AgCellRendererComponent {
  protected readonly viewModel$ = this.localStore.viewModel$;
  protected readonly ccOperations = CC_OPERATIONS;

  constructor(
      protected store: Store,
      protected localStore: CCRowMenuCellLocalStoreService,
      protected locationListService: LocationListService,
      private domSanitizer: DomSanitizer
  ) {
    super(localStore)
  }

  startCcOperation(focusedLocationId: number,
                   ccRowSetting: CCRowSetting,
                   ccOperation: CC_OPERATIONS,
                   starredState?: boolean) {
    const ccRowSettingCopy = { ...ccRowSetting };
    ccRowSettingCopy.ongoingCcOperation = ccOperation;
    this.store.dispatch(CCOperationActions.ccOperation({
      focusedLocationId,
      ccRowSetting: ccRowSettingCopy,
      ccOperation,
      starredState,
    }));
  }

  getMarkerLocation$(location: CCLocation): Observable<MarkerLocation> {
    return this.store.select(selectMarkerLocation(location));
  }

  getSafeSvgUrl(svgUrl: string) {
    return this.domSanitizer.bypassSecurityTrustUrl(svgUrl);
  }

  /**
   * Dispatcher
   * @param markerLocation
   * @param isCvOn
   */
  onMarkerSvgClick(markerLocation: MarkerLocation, isCvOn: boolean) {
    if (markerLocation && !isCvOn) {
      this.store.dispatch(locationListActions.markerSvgClicked({ location: markerLocation.location }));
    }
  }
}
